export const MEDIA_CENTER = __('Media Center');

// Need to be in camelCase be be recognized by the dataTable
export const pageSize = 10;

export const TAB_MEDIA_CENTER = '#tab-media_center';
export const TAB_CATEGORIES = '#tab-categories';
export const TAB_SETTINGS = '#tab-settings';

export const MEDIACENTER_MODAL_CLASSNAME = 'media-center-bo-class';

const MEDIA_CENTER_COVER_WIDTH = 650;
const MEDIA_CENTER_COVER_HEIGHT = 364;
export const MEDIA_CENTER_COVER_SIZE = {
  width: MEDIA_CENTER_COVER_WIDTH,
  height: MEDIA_CENTER_COVER_HEIGHT,
  widthString: `${MEDIA_CENTER_COVER_WIDTH}px`,
  heightString: `${MEDIA_CENTER_COVER_HEIGHT}px`,
  aspectRatio: MEDIA_CENTER_COVER_WIDTH / MEDIA_CENTER_COVER_HEIGHT,
  sizeString: `${MEDIA_CENTER_COVER_WIDTH}x${MEDIA_CENTER_COVER_HEIGHT}px`,
};
